import {
  MdOutlineDashboard,
  MdOutlineEco,
  MdOutlineApartment,
  MdOutlineHome,
  MdOutlineBusinessCenter,
  MdOutlineViewQuilt,
  MdOutlinePeopleOutline,
  MdOutlineBolt,
  MdOutlineCreditCard,
  MdOutlineDescription,
  MdOutlineTrendingUp,
  MdOutlineWarningAmber,
  MdOutlineInsights,
  MdOutlineFolder,
  MdOutlineGavel,
  MdOutlineNotifications,
  MdOutlineSettings,
  MdOutlineShield,
  MdMenu,
  MdClose,
  MdKeyboardArrowDown,
  MdOutlineLocalParking,
  MdOutlineChatBubbleOutline,
  MdOutlineInfo,
  MdOutlineSignalCellularAlt,
} from "react-icons/md";

import {
  LuPlus,
  LuSearch,
  LuExternalLink,
  LuMapPin,
  LuUser,
  LuHouse,
  LuCalendar,
  LuDollarSign,
  LuCreditCard,
  LuDownload,
  LuCar,
  LuBuilding2,
  LuZap,
  LuFileText,
  LuCircleCheck,
  LuClock,
  LuFilter,
  LuTrash2,
  LuChevronRight,
  LuChevronUp,
  LuChevronDown,
  LuArrowLeft,
  LuSparkles,
} from "react-icons/lu";

// Cockpit Icons
export const DashboardIcon = MdOutlineDashboard;
export const BusinessIcon = MdOutlineApartment;
export const MasterDataIcon = MdOutlineHome;
export const ESGIcon = MdOutlineEco;
export const TrendingUpIcon = MdOutlineTrendingUp;
export const AlertIcon = MdOutlineWarningAmber;
export const ActivityIcon = MdOutlineInsights;
export const ProjectsIcon = MdOutlineBusinessCenter;
export const ServicesIcon = MdOutlineViewQuilt;
export const PartnersIcon = MdOutlinePeopleOutline;
export const AssetsIcon = MdOutlineBolt;
export const BillingIcon = MdOutlineCreditCard;
export const DocumentsIcon = MdOutlineDescription;
export const FolderIcon = MdOutlineFolder;
export const LegalIcon = MdOutlineGavel;
export const SecurityIcon = MdOutlineShield;
export const NotificationsIcon = MdOutlineNotifications;
export const BellIcon = MdOutlineNotifications;
export const CockpitSettingsIcon = MdOutlineSettings;
export const MenuIcon = MdMenu;
export const CloseIcon = MdClose;
export const ArrowDownIcon = MdKeyboardArrowDown;
export const ChatIcon = MdOutlineChatBubbleOutline;

// Functional Icons
export const AddIcon = LuPlus;
export const SearchIcon = LuSearch;
export const ExternalLinkIcon = LuExternalLink;
export const MapPinIcon = LuMapPin;
export const UserIcon = LuUser;
export const HouseIcon = LuHouse;
export const CalendarIcon = LuCalendar;
export const DollarIcon = LuDollarSign;
export const CreditCardIcon = LuCreditCard;
export const DownloadIcon = LuDownload;
export const FleetIcon = LuCar;
export const TenantBuildingIcon = LuBuilding2;
export const ZapIcon = LuZap;
export const FileTextIcon = LuFileText;
export const CheckCircleIcon = LuCircleCheck;
export const ClockIcon = LuClock;
export const FilterIcon = LuFilter;
export const TrashIcon = LuTrash2;
export const ChevronRightIcon = LuChevronRight;
export const ChevronUpIcon = LuChevronUp;
export const ChevronDownIcon = LuChevronDown;
export const ParkingIcon = MdOutlineLocalParking;
export const InfoIcon = MdOutlineInfo;
export const SignalIcon = MdOutlineSignalCellularAlt;
export const ArrowLeftIcon = LuArrowLeft;
export const SparklesIcon = LuSparkles;
